import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSwissanalyticaIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 216 216",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .cls-1 {\n        fill: #ccc;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #da0033;\n      }\n\n      .cls-4 {\n        fill: #cbcbcb;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-3",
			width: 216,
			height: 216,
			rx: 35,
			ry: 35
		}),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("rect", {
				className: "cls-1",
				x: 97.36,
				y: 49.5,
				width: 21.27,
				height: 48.45
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "cls-4",
				x: 118.64,
				y: 97.95,
				width: 47.86,
				height: 21.27
			}),
			/* @__PURE__ */ _jsx("polygon", {
				className: "cls-2",
				points: "97.36 97.95 49.5 97.95 49.5 119.23 97.36 119.23 97.36 166.5 118.64 166.5 118.64 119.23 118.64 97.95 97.36 97.95"
			})
		] })
	]
});
export default SvgSwissanalyticaIcon;
